var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("button", {
    directives: [
      {
        name: "tooltip",
        rawName: "v-tooltip",
        value: "뒤로가기",
        expression: "'뒤로가기'",
      },
    ],
    staticClass:
      "w-6 h-6 rounded bg-arrow-left transition-all hover:bg-gray-100",
    on: {
      click: function ($event) {
        return _vm.$emit("click")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }